import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';
import {getDirectoryStatusTextKey} from '../../../directory-integration.functions'
export class Controller {

    /** @ngInject */
    constructor($state, DirectoriesResource, Alert) {
        this.$state = $state;
        this.DirectoriesResource = DirectoriesResource;
        this.Alert = Alert;
    }

    $onInit() {
        this.st = new SmartTable();
    }

    getDirectoryStatus() {
        this.DirectoriesResource.getDirectoryStatus(
            this.companyId,
            this.directory,
        )
        .then((directoryStatus) => {
            this.directoryStatus = directoryStatus;
            this.Alert('success', 'company.directory-integration.manage.sync-and-prov.refresh-status.success');
        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        });
    }

    directorySync() {
        this.DirectoriesResource.scimSync(
            this.companyId,
            this.directory.id,
        )
        .then(() => {
            this.$state.go('.', {}, { reload: '.' });
            this.Alert('success', 'company.directory-integration.manage.sync-and-prov.sync.success');
        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        });
    }

    directoryProvisioning() {
        this.DirectoriesResource.scimProvisioning(
            this.companyId,
            this.directory.id,
        )
        .then(() => {
            this.$state.go('.', {}, { reload: '.' });
            this.Alert('success', 'company.directory-integration.manage.sync-and-prov.provisioning.success');
        })
        .catch((error) => {
            this.Alert('danger', error.data.message);
        });
    }

    getStatusKey() {
        return getDirectoryStatusTextKey(this.directoryStatus.ongoingOperation);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/scim/sync-and-prov/directory-manage-sync-and-prov-scim.controller.js